module.exports = __webpack_public_path__ + "media/images/s4p-logo-d46e2cde0390acafae1f6149c32f5a40.svg";